import React from 'react';

const Support = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Support
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            Our support team is dedicated to helping you resolve issues quickly and efficiently. Whether you are experiencing technical problems, need guidance on best practices, or have questions about our services, we're here to assist you every step of the way.
          </p>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-4">How We Help</h2>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>24/7 technical support for critical issues</li>
            <li>Expert troubleshooting and root cause analysis</li>
            <li>Guidance on Kubernetes, OpenShift, and cloud-native technologies</li>
            <li>Proactive monitoring and health checks (for managed services customers)</li>
            <li>Access to knowledge base and best practice documentation</li>
          </ul>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">Contact Support</h2>
          <p className="text-gray-700 mb-4">
            For immediate assistance, email us at <a href="mailto:support@fepsec.com" className="text-primary underline">support@fepsec.com</a> or use our <a href="/contact" className="text-primary underline">Contact Us</a> form. Our team will respond as soon as possible.
          </p>
          <p className="text-gray-700">
            For existing customers, please include your company name and a brief description of your issue to help us serve you faster.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Support;
